// Port de app/(tabs)/espelho.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const EspelhoScreen = lazy(() => import("@/screens/Espelho"));

export default function EspelhoRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <EspelhoScreen />
    </Carregando>
  ) : null;
}
